module.exports = __webpack_public_path__ + "src/assets/img/guy_left.52d8bac1.png";